export default __webpack_public_path__ + "static/media/crypto.8770a5b5.png";